module.exports = __webpack_public_path__ + "img/linkedin.5b506892.svg";